import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'features.filterPage.title',
    defaultMessage: 'Filtri',
    description: '',
  },
  resetFilter: {
    id: 'features.filterPage.resetFilter',
    defaultMessage: 'Reset filtri',
    description: '',
  },

  applyFilter: {
    id: 'features.filterPage.cancelFilter',
    defaultMessage: 'Applica filtri',
    description: '',
  },
  headColumnAllLettersConfirmStatus: {
    id: 'features.filterPage.headColumnAllLettersConfirmStatus',
    defaultMessage: 'Stato',
    description: '',
  },
  headColumnAllLettersConfirmOperation: {
    id: 'features.filterPage.headColumnAllLettersConfirmOperation',
    defaultMessage: 'Tutte le lettere conferma operazione',
    description: '',
  },
  headColumnAllLettersDividends: {
    id: 'features.filterPage.headColumnAllLettersDividends',
    defaultMessage: 'Tutte le lettere dividendi',
    description: '',
  },
  headColumnAllWelcomeLetters: {
    id: 'features.filterPage.headColumnAllWelcomeLetters',
    defaultMessage: 'Tutte le lettere di benvenuto',
    description: '',
  },
  headColumnAllOtherLetters: {
    id: 'features.filterPage.headColumnAllOtherLetters',
    defaultMessage: 'Tutte le altre lettere',
    description: '',
  },
  headColumnSelectTimespan: {
    id: 'features.filterPage.headColumnSelectTimespan',
    defaultMessage: 'Seleziona periodo',
    description: '',
  },
});
